module.exports = __webpack_public_path__ + "img/social_recruitment.804f449.webp";